import { Spin } from 'antd';
import type { ReactNode } from 'react';
import cn from '../lib/cn';
const WithLoader = ({
  children,
  isLoading,
  className,
}: {
  children: ReactNode;
  isLoading: boolean;
  height?: number;
  className?: string;
}) => {
  return (
    <div className="relative">
      {isLoading && (
        <div
          className={cn(
            'absolute left-0 right-0 top-0 bottom-0 bg-white/80 dark:bg-theme-gray-700/80 z-50 w-ful h-full flex items-center justify-center flex-col gap-2',
            className,
          )}
        >
          <Spin className="" size="large" />
          <span className="text-display-body font-medium text-sm ml-2">
            Loading...
          </span>
        </div>
      )}
      {children}
    </div>
  );
};

export default WithLoader;
